import { createFileRoute } from '@tanstack/react-router';

import { DictionariesPage } from '@/features/catalog/DictionariesPage';

/** Справочники значений — подчинённая страница каталога, как и схемы нумерации. */
export const Route = createFileRoute('/_app/catalog_/dictionaries')({
  component: DictionariesPage,
});
